import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const appInstance = initializeApp(config)
export const auth = getAuth(appInstance)
export const googleProvider = new GoogleAuthProvider()
export const app = appInstance
const DEFAULT_REGION = import.meta.env.VITE_FIREBASE_REGION || 'us-central1'
export function getFns() { return getFunctions(app, DEFAULT_REGION) }
export const db = getFirestore(appInstance)
export const storage = getStorage(appInstance)
export default appInstance
